<!-- Contenedor principal de la lista genérica -->
<div class="generic-list-container">
  <!-- Encabezado con contador de resultados -->
  <div class="mb-3 d-flex flex-wrap justify-content-between align-items-center" *ngIf="showResultsCount">
    <ul class="list-unstyled d-block mb-0">
      <li class="d-block d-md-inline">
        {{ resultsLabel | translateAsync }}:
        <span class="fw-bold">{{ serverSidePagination ? totalItems : filteredItemsCount }}</span>
      </li>
    </ul>
  </div>

  <!-- Filtros activos (si existen) -->
  <div class="row mb-3" *ngIf="showFilters && activeFilters && activeFilters.length > 0">
    <div class="col-12">
      <a
        *ngFor="let filter of activeFilters"
        class="btn btn-xs btn-secondary rounded-pill me-1 mb-1"
        (click)="clearFilter(filter.parameter)"
        role="button">
        {{ filter.label | translateAsync }}: {{ filter.value | translateAsync }}
        <i class="fa-solid fa-xmark ms-1"></i>
      </a>
    </div>
  </div>

  <!-- Sección de tabla -->
  <div class="table-container">
    <div class="ps-4 pt-3 pe-4 pb-5 bg-white rounded-3">
      <div class="table-responsive">
        <table class="table align-middle" [class.table-hover]="hoverEffect && clickableRows">
          <!-- Encabezado de tabla -->
          <thead class="text-primary text-uppercase align-top">
            <tr>
              <th
                *ngFor="let column of columns"
                [class]="'border-bottom-0 text-' + getTextAlign(column) + ' ' + (column.class || '')"
                [style.width]="column.width"
                [class.cursor-pointer]="isSortable(column)"
                (click)="toggleSort(column)">
                <div class="d-flex align-items-center" [class.justify-content-end]="column.align === 'right'" [class.justify-content-center]="column.align === 'center'">
                  <!-- Etiqueta de columna con soporte de traducción -->
                  <span *ngIf="column.translateKey">
                    {{ column.translateKey | translateAsync }}
                  </span>
                  <span *ngIf="!column.translateKey">
                    {{ column.header }}
                  </span>

                  <!-- Icono de ordenamiento -->
                  <i
                    *ngIf="isSortable(column)"
                    class="fa-solid ms-2"
                    [ngClass]="getSortIcon(column)"
                    [class.text-muted]="sortColumn !== column.field">
                  </i>
                </div>
              </th>
            </tr>
          </thead>

          <!-- Cuerpo de tabla -->
          <tbody>
            <!-- Filas de datos -->
            <tr
              *ngFor="let item of processedItems"
              (click)="handleRowClick(item)"
              [class.cursor-pointer]="clickableRows"
              [style.pointer-events]="clickableRows ? 'auto' : 'none'">

              <td
                *ngFor="let column of columns"
                [class]="'text-' + getTextAlign(column) + ' ' + (column.class || '')">

                <!-- Template personalizado -->
                <ng-container *ngIf="column.customTemplate">
                  <ng-container *ngTemplateOutlet="column.customTemplate; context: { $implicit: item, value: getValue(item, column.field) }"></ng-container>
                </ng-container>

                <!-- Badge con soporte para clases condicionales -->
                <ng-container *ngIf="!column.customTemplate && column.format === 'badge'">
                  <div [class.text-start]="column.align === 'left'" [class.text-end]="column.align === 'right'" [class.text-center]="column.align === 'center'">
                    <span
                      class="badge text-uppercase"
                      [ngClass]="getBadgeClass(item, column)">
                      {{ getFormattedValue(item, column) | translateAsync }}
                    </span>
                  </div>
                </ng-container>

                <!-- Valor normal -->
                <ng-container *ngIf="!column.customTemplate && column.format !== 'badge'">
                  <div [class.text-truncate]="column.class?.includes('text-break') === false">
                    {{ getFormattedValue(item, column) }}
                  </div>
                </ng-container>
              </td>
            </tr>

            <!-- Mensaje cuando no hay datos -->
            <tr *ngIf="processedItems.length === 0">
              <td [attr.colspan]="columns.length" class="text-center text-muted py-4">
                {{ noDataMessage | translateAsync }}
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Sección de paginación -->
  <div class="pagination-container" *ngIf="enablePagination">
    <div class="row custom-pagination">
      <div class="col-12">
        <mat-paginator
          [length]="serverSidePagination ? totalItems : filteredItemsCount"
          [pageSizeOptions]="pageSizeOptions"
          [pageSize]="currentPageSize"
          [pageIndex]="currentPageIndex"
          (page)="handlePageChange($event)"
          showFirstLastButtons>
        </mat-paginator>
      </div>
    </div>
  </div>
</div>

